import React from "react";
import "./about.css";
import mm from "../../images/mm.png";
import rrq2 from "../../images/rrq2.png";

const About = () => {
  return (
    <div className="about-container">
      <div className="about">
        <h1>THE RESZKO NATION</h1>
        <img className="rrq2" src={rrq2}></img>

        <div className="about-top">
          <div className="about-top-left">
            <img className="mm" src={mm}></img>
          </div>

          <div className="about-top-right">
            <h2>ABOUT US</h2>
            <h3>Built for a Higher Standard</h3>
            <p>
              Reszko Nation was built for professionals who refuse to operate at
              an average level. With more than 30 leading carriers, our platform
              provides the scale, structure, and support required to compete at
              the highest level.
            </p>

            <h3>A Culture of Discipline & Performance</h3>
            <p>
              This is not a typical agency environment. It is a culture designed
              to identify, develop, and elevate individuals prepared to think
              bigger, execute better, and lead with accountability.
            </p>

            <h3>Where Ambition Becomes Momentum</h3>
            <p>
              Our team is composed of driven professionals committed to growth
              and long-term success. If you are serious about excellence, the
              standard is already set.
            </p>
          </div>
        </div>
        <div className="about-bottom">
          <a href="/contact">
            <button className="hero-btn">Request an Interview</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
